// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ec27d73","455":"cc94703e"}[chunkId] + ".chunk.js";
};